module.exports = __webpack_public_path__ + "static/img/platform3.2f390811.png";